<script>
import { createNamespacedHelpers } from 'vuex'
const { mapActions: attendanceActionsMap } = createNamespacedHelpers('attendance')

export default {
  name: 'BaseHypothesis',
  render() {
    return this.$scopedSlots.default
  },
  computed: {
    hypothesis() {
      return this.getHypothesisText()
    },
  },
  watch: {
    hypothesis(newVal) {
      this.setAttendanceHypothesis(newVal)
    },
  },
  methods: {
    ...attendanceActionsMap(['setAttendanceHypothesis']),
    /**
     * Método que deve devolver o texto calculado da hipótese
     */
    getHypothesisText() {
      throw new Error('You must implement getHypothesisText method in your child component!')
    },
  },
}
</script>
